import { render, staticRenderFns } from "./CallInquiries.vue?vue&type=template&id=23d2d380&scoped=true&"
import script from "./CallInquiries.vue?vue&type=script&lang=js&"
export * from "./CallInquiries.vue?vue&type=script&lang=js&"
import style0 from "./CallInquiries.vue?vue&type=style&index=0&id=23d2d380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d2d380",
  null
  
)

export default component.exports